import React from "react";
import PropTypes from "prop-types";
import { AssistantIframe } from "./styled.js";

const AssistantFrame = ({
  assistantUrl,
  height,
  mobileWidth,
  tabletWidth,
  desktopWidth,
  isVisible,
  positionTop,
  positionLeft
}) => {
  return (
    <AssistantIframe
      title="Micromedex Assistant"
      src={assistantUrl}
      scrolling="no"
      data-testid="assistant-Iframe"
      $height={height}
      $mobileWidth={mobileWidth}
      $tabletWidth={tabletWidth}
      $desktopWidth={desktopWidth}
      $isVisible={isVisible}
      $positionTop={positionTop}
      $positionLeft={positionLeft}
    ></AssistantIframe>
  );
};

AssistantFrame.propTypes = {
  assistantUrl: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  mobileWidth: PropTypes.string.isRequired,
  tabletWidth: PropTypes.string.isRequired,
  desktopWidth: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  positionTop: PropTypes.string,
  positionLeft: PropTypes.string
};

AssistantFrame.displayName = "AssistantFrame";

export default AssistantFrame;
